module.exports = __webpack_public_path__ + "media/images/gfx/reset_password_xs-fbc164ddc4b2b1416528d269420248e7.gif";